import {
  NewEducationLinkShape,
  NewInterviewShape,
} from "../interfaces/classTypes";

let allIncludedNewEducationLinks = [];
export class NewEducationLink {
  public id: number;
  public label: string;
  public parentInterview: NewInterviewShape;

  constructor(data: NewEducationLinkShape, parent: NewInterviewShape) {
    this.id = data.id;
    this.label = data.label;
    this.parentInterview = parent;
    this.save();
  }
  save() {
    allIncludedNewEducationLinks.push(this);
  }

  static allIncludedNewEducationLinks() {
    return allIncludedNewEducationLinks;
  }

  static find_by_id(id) {
    return allIncludedNewEducationLinks.find((i) => i.id == parseInt(id));
  }
}
